<template>
  <tab-talentq :talentq="talentq" @load-pdf-report="loadPdfReport" />
</template>

<script>
  import axios from 'axios';
  import { mapGetters } from 'vuex';
  import TabTalentq from './components/tab-talentq';

  export default {
    name: 'TabTalentqDefault',

    components: { TabTalentq },

    computed: {
      ...mapGetters('response', ['talentq', 'response_id'])
    },

    methods: {
      loadPdfReport() {
        return axios
          .get(`/1.0/talentq/candidate/${this.response_id}/report-pdf`)
          .then(res => {
            window.location = res.data.pdf_report;
          })
          .catch(() => {
            this.$noty.error(this.$tr('common.error.networkError'));
          });
      }
    }
  };
</script>
